import { gql } from '@apollo/client';

export const EXPORT_BILLING_PERIOD_SUMMARY = gql`
  mutation ExportBillingPeriodSummary($filters: BillingPeriodSummaryFilterInput) {
    exportBillingPeriodSummary(filters: $filters) {
      success
      message
      messageKey
      data
    }
  }
`;
